<template>
  <div id="app">
    <transition
      name="move"
      mode="out-in"
    >
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    key() {
      return this.$route.fullPath
    }
  },
}
</script>
<style>
#app {
    height: 100%;
    background-color: #f0f2f5;
    min-width: 1300px;
}
body, html {
    margin: 0;
    padding: 0;
    height: 100%;
}
.el-scrollbar__wrap {
  overflow-x: hidden;
  overflow-y: scroll;
}

.el-scrollbar__bar.is-horizontal {
  display: none;
}

.el-scrollbar__view {
  overflow: hidden;
}
 .el-loading-mask {
  /* position: fixed !important; */
  filter: opacity(80%);
  background-color: white !important;
 }
.el-loading-spinner {
  background-image: url("assets/base/img/loading.gif");
  background-repeat: no-repeat;
  height: 100%;
  background-position: center;
  top: 0 !important;
}
.el-loading-spinner .circular {
  display: none;
}
.el-notification {
  background: #e6f9ff !important;
}
.el-notification__group {
  width: 100% !important;
}
.el-notification__content {
  color: #1647cc !important;
}
[class^="el-icon-fa"],
[class*=" el-icon-fa"] {
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome !important;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
